import React from "react"
import PropTypes from "prop-types"
import {Card, Typography, Tag, Row, Col } from "antd"
import styles from "../../index.module.css"
import { useTranslation } from "react-i18next"
import PhotoSlider from "components/common/PhotoSlider"

const { Text, Paragraph } = Typography

const AboutTripCard = React.memo(({ description, boat }) => {
  const { t } = useTranslation()
  return (
    <Card className={styles.mainCard} title="About The Trip">
      <div className={`${styles.paragraph} p-xl`}>
        <Paragraph className={styles.description}>{description}</Paragraph>
        {boat?.length > 0 && (
          <div className="mt-45">
            <h2 className="h3">{t("trip.labels.equipment")}</h2>
            {boat?.map((item) => {
              const tags = item.custom_info
              return (
                <Card key={item.id} className="mb-l">
                  <Row gutter={[16, 16]} align="middle">
                    <Col xs={24} sm={6} className="mt-l">
                      <PhotoSlider photos={item.properties} cropped_photos={item.cropped_photos} preview />
                    </Col>

                    <Col xs={24} sm={16} className="mt-l ml-l">
                      <h3>{item.name}</h3>
                      <p style={{ display: "-webkit-box", WebkitLineClamp: 4, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                        {item.description}
                      </p>
                      <div>
                        {tags.map((tag) => (
                          <Tag key={tag} style={{ marginBottom: "8px" }} className="mr-s">
                            {tag}
                          </Tag>
                        ))}
                      </div>
                    </Col>
                  </Row>
                </Card>
              )
            })}
          </div>
        )}
      </div>
    </Card>
  )
})

AboutTripCard.propTypes = {
  description: PropTypes.string,
  boat: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      model: PropTypes.string,
      image: PropTypes.string,
      photos: PropTypes.arrayOf(PropTypes.string),
      description: PropTypes.string,
      custom_info: PropTypes.array,
    })
  )
}

AboutTripCard.displayName = "AboutTripCard"

export default AboutTripCard
